import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setToken, clearToken } from '@/store';
import type { RootState } from '@/store';

export function useAdminAuth() {
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.login.token);

  useEffect(() => {
    const storedToken = localStorage.getItem('adminToken');
    if (storedToken && !token) {
      dispatch(setToken(storedToken));
    }
  }, [dispatch, token]);

  const handleLogin = useCallback(
    (newToken: string) => {
      localStorage.setItem('adminToken', newToken);
      dispatch(setToken(newToken));
    },
    [dispatch]
  );

  const handleLogout = useCallback(() => {
    localStorage.removeItem('adminToken');
    dispatch(clearToken());
  }, [dispatch]);

  return {
    token,
    isAuthenticated: !!token,
    handleLogin,
    handleLogout,
  };
}
